import { RxHeight } from "react-icons/rx"
import AnalyticsSvg from "../components/SVG/AnalyticsSvg"
import AnalyticsSvg2 from "../components/SVG/AnalyticsSvg2"
import ApplicationsSvg from "../components/SVG/ApplicationsSvg"
import InsuranceSvg from "../components/SVG/InsuranceSvg"
import LeadsSvg from "../components/SVG/LeadsSvg"
import RejectedApplicationsSvg from "../components/SVG/RejectedApplicationsSvg"
// import ExcessManagementSvg from "../components/SVG/ExcessManagementSvg"
import ReportsSvg from "../components/SVG/ReportsSvg"
import TaskDashboardSvg from "../components/SVG/TaskDashboardSvg"
import TrancheSvg from "../components/SVG/TrancheSvg"
import TVRSvg from "../components/SVG/TVRSvg"
import UserManagementSvg from "../components/SVG/UserManagementSvg"
import './../index.css'
import BranchSvg from "../components/SVG/BranchSvg"
import DeletedApplicationsSvg from "../components/SVG/DeletedApplicationsSvg"
import TeamOverviewSvg from "../components/SVG/TeamOverviewSvg"

/**
 * SIDEBAR_ITEMS
 * 
 * Each entry describes one sidebar icon.
 * `permission` maps to a permission_code that comes from your login API response
 * on officer.permissions[].permission_code
 * 
 */
export const MAIN_SIDEBAR_MENU = {
    "applications": {
        key: "applications",
        tooltip: "Applications",
        permissions: [
            {
                permission_code: "APPLICATION_VIEW"
            },
        ],
        route: "/applications",
        icon: ApplicationsSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "leads": {
        key: "leads",
        tooltip: "Leads",
        permissions: [
            {
                permission_code: "LEAD_VIEW"
            },
        ],
        route: "/leads",
        icon: LeadsSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "tvr": {
        key: "tvr",
        tooltip: "TVR",
        permissions: [
            {
                permission_code: "TVR_VIEW"
            },
        ],
        route: "/tvr",
        icon: TVRSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "tranche": {
        key: "tranche",
        tooltip: "Tranches",
        permissions: [
            {
                permission_code: "TRANCHE_OPEN"
            },
        ],
        route: "/tranche-view",
        icon: TrancheSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "tvr": {
        key: "tvr",
        tooltip: "TVR",
        permissions: [
            {
                permission_code: "TVR_VIEW"
            },
        ],
        route: "/tvr",
        icon: TVRSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "38px" },
    },
    "insurance": {
        key: "insurance",
        tooltip: "Insurance",
        permissions: [
            {
                permission_code: "INSURANCE_VIEW"
            },
        ],
        route: "/insurance",
        icon: InsuranceSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "reports": {
        key: "reports",
        tooltip: "Reports",
        permissions: [
            {
                permission_code: "REPORTS_VIEW"
            },
        ],
        route: "/reports",
        icon: ReportsSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "analytics": {
        key: "analytics",
        tooltip: "Application Stage Summary",
        permissions: [
            {
                permission_code: "APPLICATION_STAGES_SUMMARY_VIEW"
            },
        ],
        route: "/analytics",
        icon: AnalyticsSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "analytics-dashboard": {
        key: "analytics-dashboard",
        tooltip: "Analytics",
        permissions: [
            {
                permission_code: "ANALYTICS_VIEW"
            },
        ],
        route: "/analytics-dashboard",
        icon: AnalyticsSvg2,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "rejected-applications": {
        key: "rejected-applications",
        tooltip: "Rejected Applications",
        permissions: [
            {
                permission_code: "VIEW_REJECTED_APPLICATIONS"
            },
        ],
        route: "/rejected-applications",
        icon: RejectedApplicationsSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    // "excess-management": {
    //     key: "excess-management",
    //     tooltip: "Excess Management",
    //     permissions: [
    //         {
    //             permission_code: "VIEW_REJECTED_APPLICATIONS" 
    //         },
    //     ],
    //     route: "/excess-management",
    //     icon: ExcessManagementSvg,
    //     iconProps: { fillColor: "var(--icon-fill-color)", size: "48px" },
    // },
    "query-management": {
        key: "query-management",
        tooltip: "Task Management Dashboard",
        permissions: [
            {
                permission_code: "QMS_STAGE_VIEW"
            },
        ],
        route: "/task-management/dashboard",
        icon: TaskDashboardSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    "user-management": {
        key: "user-management",
        tooltip: "User Management",
        permissions: [
            {
                permission_code: "USER_MANAGEMENT_VIEW"
            }
        ],
        route: "/user-management",
        icon: UserManagementSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", size: "28px" },
    },
    // "branch-dashboard": {
    //     key: "branch-dashboard",
    //     tooltip: "Branch Dashboard",
    //     permissions: [
    //         {
    //             permission_code: "BRANCH_DASHBOARD_VIEW"
    //         }
    //     ],
    //     route: "/branch-dashboard",
    //     icon: BranchSvg,
    //     iconProps: { fillColor: "var(--icon-fill-color)", width: "32px", height: "32px" },
    // },
    "deleted-applications": {
        key: "deleted-applications",
        tooltip: "Deleted Applications",
        permissions: [
            {
                permission_code: "VIEW_DELETED_APPLICATIONS"
            }
        ],
        route: "/deleted-applications",
        icon: DeletedApplicationsSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", width: "32px", height: "32px" },
    },
    "team-overview": {
        key: "team-overview",
        tooltip: "Team Overview",
        permissions: [
            {
                permission_code: "VIEW_TEAM_OVERVIEW"
            }
        ],
        route: "/team-overview?tab=staff-view",
        icon: TeamOverviewSvg,
        iconProps: { fillColor: "var(--icon-fill-color)", width: "32px", height: "32px" },
    },
}